import React, { Component } from 'react'
import EmailRegistrationForm from './EmailRegistrationForm'
import UserDetailForm from './UserDetailForm'

export default class GoogleStep extends Component {
  render() {
    const { onSubmit, loading } = this.props

    return (
      <div className="signup__form signup__form__google">
        <form>
          <EmailRegistrationForm {...this.props} hideComplete={true} />
          <UserDetailForm {...this.props} hideComplete={true} />

          <div style={{width: "100%", textAlign: "center"}}>
            <input type="submit" value="Register with Google!" onClick={onSubmit} disabled={loading} className={`next__button ${loading ? 'loading' : ''}`} />
          </div>
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SignupWidget/GoogleStep.js